/* Softheld Stories — Kinder Yearbook TEACHER consent form.
   A near-duplicate of softheld-consent-form.js for the teacher's own page (see
   softheld-teacher-consent-form.liquid) — same code gate, per-centre config,
   conditional sections, character counters and photo handling, but pointed at
   the teacher's own name/declaration fields instead of the child's/guardian's. */
(function () {
  var form = document.querySelector('[data-sh-consent-form]');
  if (!form) return;

  var MAX_PHOTOS = 2;
  var MAX_EDGE = 1600;
  var Q_FIRST = 0.82;
  var Q_RETRY = 0.6;
  var SIZE_CAP = 1200000;
  var contactEmail = form.getAttribute('data-contact-email') || 'the studio';

  var submitUrl = form.getAttribute('action') || '';
  var centreUrl = (form.getAttribute('data-centre-endpoint') || '').trim() ||
    submitUrl.replace(/\/submit\/?(\?.*)?$/i, '/centre');

  var gate = form.querySelector('[data-cf-gate]');
  var gateGo = form.querySelector('[data-cf-gate-go]');
  var gateErr = form.querySelector('[data-cf-gate-error]');
  var codeInput = form.querySelector('[data-cf-code]');
  var body = form.querySelector('[data-cf-body]');
  var confirmed = form.querySelector('[data-cf-confirmed]');
  var intro = form.querySelector('[data-cf-intro]');
  var introText = form.querySelector('[data-cf-intro-text]');
  var centreNameInput = form.querySelector('[data-cf-centre-name]');
  var roomSelect = form.querySelector('[data-cf-room-select]');
  var roomText = form.querySelector('[data-cf-room-text]');

  var summary = form.querySelector('[data-cf-summary]');
  var msg = form.querySelector('[data-cf-msg]');
  var submitBtn = form.querySelector('[data-cf-submit]');
  var photoInput = form.querySelector('[data-cf-photos]');
  var noPhoto = form.querySelector('[data-cf-nophoto]');
  var thumbs = form.querySelector('[data-cf-thumbs]');
  var photoMsg = form.querySelector('[data-cf-photo-msg]');
  var orderLine = form.querySelector('[data-cf-order-line]');
  var orderFooter = form.querySelector('[data-cf-order-footer]');
  var teacherReviewLine = form.querySelector('[data-cf-teacher-review]');

  var photos = [];
  var centreHidden = { photos: false, order: false };
  var unlocked = false;

  /* ---------- date (displayed, never submitted) ---------- */
  var today = new Date().toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
  form.querySelectorAll('[data-cf-today]').forEach(function (el) { el.textContent = today; });

  /* ---------- code gate ---------- */
  function gateError(text) {
    gateErr.textContent = text;
    gateErr.hidden = false;
    try { gateErr.focus && gateErr.focus(); } catch (e) {}
  }

  function applyCentre(c) {
    if (confirmed) {
      confirmed.textContent = 'Code accepted for ' + (c.centre || 'your kinder') + '.';
      confirmed.hidden = false;
    }
    if (codeInput && c.code) codeInput.value = c.code;
    if (centreNameInput && c.centre) {
      centreNameInput.value = c.centre;
      centreNameInput.readOnly = true;
      // the "Code accepted — X" line already names the centre; hide the duplicate field (still submits)
      var cwrap = centreNameInput.closest('[data-cf-centre-field]') || centreNameInput.closest('.sh-cf__field');
      if (cwrap) cwrap.hidden = true;
    }

    var rooms = Array.isArray(c.rooms) ? c.rooms.filter(function (r) { return String(r).trim(); }) : [];
    if (rooms.length && roomSelect && roomText) {
      roomSelect.innerHTML = '';
      // one room → it's the only option and selects itself; multiple → force a choice
      if (rooms.length > 1) {
        var blank = document.createElement('option');
        blank.value = ''; blank.textContent = 'Choose…';
        roomSelect.appendChild(blank);
      }
      rooms.forEach(function (r) {
        var o = document.createElement('option');
        o.value = String(r).trim(); o.textContent = String(r).trim();
        roomSelect.appendChild(o);
      });
      roomSelect.disabled = false;
      roomSelect.hidden = false;
      roomText.disabled = true;
      roomText.hidden = true;
    }

    if (c.collectPhotos === false) centreHidden.photos = true;
    if ((c.bookOrder || 'standard') === 'none') centreHidden.order = true;

    if (teacherReviewLine && c.teacherReview !== false) teacherReviewLine.hidden = false;

    if (orderFooter && (c.ordersClose || c.paymentDetails)) {
      var parts = [];
      parts.push(c.ordersClose
        ? 'You have until ' + c.ordersClose + ' to let me know.'
        : 'Your kinder will confirm the order dates.');
      if (c.paymentDetails) parts.push(c.paymentDetails);
      parts.push('Questions or changes: ' + contactEmail + '.');
      orderFooter.textContent = parts.join(' ');
    }

    if (c.introNote && introText && intro) {
      introText.textContent = c.introNote;
      intro.hidden = false;
    }

    [['1', c.extra1], ['2', c.extra2]].forEach(function (pair) {
      if (!pair[1]) return;
      var wrap = form.querySelector('[data-cf-extra="' + pair[0] + '"]');
      if (!wrap) return;
      wrap.querySelector('[data-cf-extra-label]').textContent = pair[1];
      wrap.hidden = false;
    });
  }

  function revealBody() {
    unlocked = true;
    if (gate) gate.hidden = true;
    body.hidden = false;
    applyInclude(false);
    // put the start of the form at the top of the screen, not mid-page
    try { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    catch (e) { try { window.scrollTo(0, 0); } catch (e2) {} }
    var first = form.querySelector('[name="teacher_full_name"]');
    if (first) {
      try { first.focus({ preventScroll: true }); }
      catch (e) { try { first.focus(); } catch (e2) {} }
    }
  }

  function unlock() {
    var code = (codeInput.value || '').trim();
    if (!code) { gateError("Enter your kinder's code."); return; }
    gateErr.hidden = true;
    gateGo.disabled = true;
    gateGo.textContent = 'Checking…';

    var done = function () { gateGo.disabled = false; gateGo.textContent = 'Continue'; };

    if (!centreUrl) { revealBody(); done(); return; }

    fetch(centreUrl + '?code=' + encodeURIComponent(code), { method: 'GET' })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        if (data && data.ok) { applyCentre(data); revealBody(); }
        else { gateError((data && data.message) || "That code isn't one of ours. Check it with your kinder and try again."); }
      })
      .catch(function () {
        gateError("I couldn't check your code just now. Check your connection and try again.");
      })
      .then(done);
  }

  if (gate && gateGo && codeInput) {
    gateGo.hidden = false;
    body.hidden = true;
    gateGo.addEventListener('click', unlock);
    codeInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); unlock(); }
    });
    var urlCode = new URLSearchParams(location.search).get('code');
    if (urlCode) { codeInput.value = urlCode; unlock(); }
  }

  /* ---------- conditional sections ---------- */
  function currentInclude() {
    var checked = form.querySelector('input[name="include"]:checked');
    return checked ? checked.value : 'yes';
  }

  function applyInclude(focusTarget) {
    var inc = currentInclude();
    form.querySelectorAll('[data-cf-when]').forEach(function (el) {
      var show = el.getAttribute('data-cf-when') === inc;
      el.hidden = !show;
      el.querySelectorAll('input, select, textarea').forEach(function (f) {
        if (f.name === 'website') return;
        f.disabled = !show;
      });
    });

    // per-centre permanent hides win over the include logic
    if (centreHidden.photos) forceHideSection('3');
    if (centreHidden.order) forceHideSection('order');
    // exactly one of the room select / text pair stays live, whichever is shown
    if (roomSelect && roomText) {
      if (roomSelect.hidden) roomSelect.disabled = true;
      else roomText.disabled = true;
    }

    form.querySelectorAll('[data-cf-sub]').forEach(function (el) {
      el.textContent = el.getAttribute('data-cf-sub-' + inc) || el.textContent;
    });
    form.querySelectorAll('[data-cf-num]').forEach(function (el) {
      el.textContent = el.getAttribute('data-cf-num-' + inc) || el.textContent;
    });
    form.querySelectorAll('[data-cf-h]').forEach(function (el) {
      el.textContent = el.getAttribute('data-cf-h-' + inc) || el.textContent;
    });
    syncOrderLine();

    if (focusTarget) {
      var t = inc === 'no'
        ? form.querySelector('[data-cf-when="no"]')
        : form.querySelector('[data-cf-section="2"]');
      if (t) { try { t.focus(); } catch (e) {} }
    }
  }

  function forceHideSection(id) {
    var s = form.querySelector('[data-cf-section="' + id + '"]');
    if (!s) return;
    s.hidden = true;
    s.querySelectorAll('input, select, textarea').forEach(function (f) { f.disabled = true; });
  }

  form.querySelectorAll('input[name="include"]').forEach(function (r) {
    r.addEventListener('change', function () { applyInclude(true); });
  });

  /* ---------- character counters ---------- */
  function cp(str) { return Array.from(str).length; }

  form.querySelectorAll('[data-cf-count]').forEach(function (out) {
    var limit = parseInt(out.getAttribute('data-cf-count'), 10);
    var input = out.closest('label').querySelector('input, textarea');
    if (!input) return;
    var live = document.createElement('span');
    live.className = 'sh-cf__count-live';
    live.setAttribute('aria-live', 'polite');
    out.removeAttribute('aria-live');
    out.insertAdjacentElement('afterend', live);
    var t = null;
    function update() {
      var left = limit - cp(input.value);
      if (left < 0) left = 0;
      out.textContent = left + ' characters left';
    }
    input.addEventListener('input', function () {
      update();
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var left = limit - cp(input.value);
        live.textContent = (left < 0 ? 0 : left) + ' characters left';
      }, 600);
    });
    update();
  });

  /* ---------- "if you asked for a copy" line ---------- */
  function syncOrderLine() {
    if (!orderLine) return;
    var wants = form.querySelector('input[name="order_intent"]:checked');
    orderLine.hidden = !(currentInclude() === 'yes' && wants && wants.value === 'yes' && !centreHidden.order);
  }
  form.querySelectorAll('input[name="order_intent"]').forEach(function (r) {
    r.addEventListener('change', syncOrderLine);
  });

  /* ---------- photos ---------- */
  function loadImage(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error('image')); };
      img.src = url;
    });
  }
  function toJpeg(canvas, q) {
    return new Promise(function (res) { canvas.toBlob(function (b) { res(b); }, 'image/jpeg', q); });
  }
  function downscale(file) {
    return loadImage(file).then(function (img) {
      var w = img.naturalWidth, h = img.naturalHeight;
      var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
      var cw = Math.round(w * scale), ch = Math.round(h * scale);
      var canvas = document.createElement('canvas');
      canvas.width = cw; canvas.height = ch;
      canvas.getContext('2d').drawImage(img, 0, 0, cw, ch);
      return toJpeg(canvas, Q_FIRST).then(function (blob) {
        if (blob && blob.size <= SIZE_CAP) return blob;
        return toJpeg(canvas, Q_RETRY).then(function (b2) {
          return (b2 && b2.size <= SIZE_CAP) ? b2 : null;
        });
      });
    });
  }
  function renderThumbs() {
    thumbs.innerHTML = '';
    thumbs.hidden = photos.length === 0;
    photos.forEach(function (p, i) {
      var wrap = document.createElement('div');
      wrap.className = 'sh-cf__thumb';
      var im = document.createElement('img');
      im.alt = 'Reference photo ' + (i + 1);
      im.src = URL.createObjectURL(p.blob);
      im.onload = function () { URL.revokeObjectURL(im.src); };
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'sh-cf__thumb-x';
      rm.setAttribute('aria-label', 'Remove ' + p.name);
      rm.textContent = 'Remove';
      rm.addEventListener('click', function () {
        photos.splice(i, 1); renderThumbs(); photoInput.focus();
      });
      wrap.appendChild(im); wrap.appendChild(rm); thumbs.appendChild(wrap);
    });
  }
  function sayPhoto(text) {
    if (!text) { photoMsg.hidden = true; photoMsg.textContent = ''; return; }
    photoMsg.hidden = false; photoMsg.textContent = text;
  }
  if (photoInput) {
    photoInput.addEventListener('change', function () {
      var picked = Array.prototype.slice.call(photoInput.files || []);
      photoInput.value = '';
      if (!picked.length) return;
      if (noPhoto.checked) noPhoto.checked = false;
      var room = MAX_PHOTOS - photos.length;
      if (room <= 0) { sayPhoto('You can attach at most two photos. Remove one to add another.'); return; }
      var overflowed = picked.length > room;
      picked = picked.slice(0, room);
      sayPhoto('Preparing your photo…');
      var chain = Promise.resolve();
      var failedBig = false;
      picked.forEach(function (file) {
        chain = chain.then(function () {
          return downscale(file).then(function (blob) {
            if (!blob) { failedBig = true; return; }
            photos.push({ blob: blob, name: file.name });
          }).catch(function () { failedBig = true; });
        });
      });
      chain.then(function () {
        renderThumbs();
        if (failedBig) sayPhoto('One photo is still too large after resizing. Please email it to ' + contactEmail + ' instead.');
        else if (overflowed) sayPhoto('Only the first two photos were added.');
        else sayPhoto('');
      });
    });
    noPhoto.addEventListener('change', function () {
      if (noPhoto.checked) { photos = []; renderThumbs(); sayPhoto(''); }
    });
  }

  /* ---------- submit ---------- */
  function clearErrors() {
    summary.hidden = true;
    summary.innerHTML = '';
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
    form.querySelectorAll('.sh-cf__field-error:not([data-cf-gate-error])').forEach(function (el) { el.remove(); });
  }
  function fieldError(name, text) {
    var input = form.querySelector('[name="' + (window.CSS && CSS.escape ? CSS.escape(name) : name) + '"]');
    if (!input) return;
    input.setAttribute('aria-invalid', 'true');
    var holder = input.closest('.sh-cf__field, .sh-cf__choice') || input.parentElement;
    var e = document.createElement('span');
    e.className = 'sh-cf__field-error';
    e.textContent = text;
    holder.appendChild(e);
  }
  function showSummary(headline, list) {
    summary.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'sh-body';
    p.textContent = headline;
    summary.appendChild(p);
    if (list && list.length) {
      var ul = document.createElement('ul');
      list.forEach(function (item) {
        var li = document.createElement('li'); li.textContent = item; ul.appendChild(li);
      });
      summary.appendChild(ul);
    }
    summary.hidden = false;
    try { summary.focus(); } catch (e) {}
  }
  var CONSENT_MSG = 'Please tick the permission and declaration boxes above before submitting.';

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();
    msg.textContent = '';

    var inc = currentInclude();
    var declBox = form.querySelector('[name="teacher_declaration"]');
    var declOk = inc === 'no' || (declBox && declBox.checked);
    var consentOk = inc === 'no' ||
      (form.querySelector('[name="consent_print"]').checked && form.querySelector('[name="consent_ai"]').checked);
    if (!declOk || !consentOk) { showSummary(CONSENT_MSG); return; }

    var fd = new FormData(form);
    fd.delete('photos');
    if (!noPhoto.checked) {
      photos.forEach(function (p, i) { fd.append('photos', p.blob, 'reference-' + (i + 1) + '.jpg'); });
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    fetch(form.action, { method: 'POST', body: fd })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) { return { status: r.status, data: data }; });
      })
      .then(function (res) {
        var data = res.data || {};
        if (res.status === 200 && data.ok) {
          var done = document.createElement('div');
          done.className = 'sh-cf__done';
          done.setAttribute('role', 'alert');
          done.setAttribute('tabindex', '-1');
          var h = document.createElement('h3');
          h.className = 'sh-h3';
          h.textContent = data.message || 'Thank you. Your form has been received.';
          done.appendChild(h);
          form.replaceWith(done);
          try { done.focus(); } catch (e) {}
          return;
        }
        if (Array.isArray(data.errors) && data.errors.length) {
          data.errors.forEach(function (er) { fieldError(er.field, er.message); });
          showSummary(data.error || 'Please check the highlighted fields.', data.errors.map(function (er) { return er.message; }));
        } else {
          showSummary(data.error || 'Something went wrong sending the form. Please try again in a moment.');
        }
      })
      .catch(function () {
        showSummary('The form could not be sent. Check your connection and try again, or email ' + contactEmail + '.');
      })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit this form';
      });
  });

  /* init */
  if (!gate || !gateGo) { applyInclude(false); }
  syncOrderLine();
})();
